import { i18n } from "../../../boot/i18n";
import { store } from "../../../store";

export default {
  routes: [
    {
      name: "sales-goals",
      path: "goals",
      meta: {
        auth: () => store.getters.isEmployee(),
        icon: "goal",
        title: i18n.global.t("Sales Goals"),
        crumbs: ["sales-tools"],
      },
      component: () => import("pages/employee/SalesGoals"),
    },
  ],

  dialogs: [],
};
